import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IFavouritesListState } from './interfaces';
import { getRequest } from 'api/requests';

// Загрузка списка логов
export const fetchFavourites = createAsyncThunk(
  'favouritesList/fetchFavourites',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest('favourite', {}, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const FavouritesListSelector = (
  state: RootState,
): IFavouritesListState => state.favouritesList;

export const FavouritesListLoadingSelector = createSelector(
  FavouritesListSelector,
  ({ isLoading }) => isLoading,
);

export const FavouritesListItemsSelector = createSelector(
  FavouritesListSelector,
  ({ items }) => items,
);

const initialState: IFavouritesListState = {
  isLoading: false,
  items: [],
};

const favouritesListSlice = createSlice({
  name: 'favouritesList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavourites.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(fetchFavourites.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchFavourites.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload,
      }));
  },
});

export default favouritesListSlice.reducer;
